import { render, staticRenderFns } from "./CommentIcon.vue?vue&type=template&id=b43b2e24&scoped=true"
import script from "./CommentIcon.vue?vue&type=script&lang=ts"
export * from "./CommentIcon.vue?vue&type=script&lang=ts"
import style0 from "./CommentIcon.vue?vue&type=style&index=0&id=b43b2e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43b2e24",
  null
  
)

export default component.exports